import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { SET_AREA } from 'store';
import { Redirect, useHistory } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import style from './style.module.scss';
import { api } from 'services';

const SelectArea = ({ area, setArea }) => {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    api.get('/areas').then(({ data }) => {
      if (data.length === 1) setArea(data[0]);
      else setAreas(data);
    });
  }, [setArea]);

  useEffect(() => {
    document.body.style.backgroundColor = '#5b5b5f';
    document.body.style.backgroundImage = `url('/bg-pattern.png')`;

    return () => (document.body.style = '');
  }, []);

  if (!!area || !!localStorage.area_id) return <Redirect to="/" />;

  if (areas.length === 0) return <></>;

  return (
    <Container className={style.select_area}>
      <Row className="justify-content-center">
        <Col md={8} lg={8} xl={6}>
          <Card className="bg_pattern">
            <Card.Body>
              <Row>
                <Col>
                  <div className="text-center w-75 m-auto">
                    <div className="p-1 rounded">
                      <span>
                        <img src="/logo.png" alt="SIM" height={30} />
                      </span>
                    </div>
                    <p className="text-muted mb-1 mt-3">Select the area</p>
                  </div>
                </Col>
              </Row>
              <Row>
                {areas.map((area, k) => (
                  <Col key={k} md={6} className="mt-4">
                    <Card
                      className="area text-center"
                      onClick={() => setArea(area)}
                    >
                      <Card.Body>{area.name}</Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => ({
  area: state.area
});

const mapDispatchToProps = dispatch => ({
  setArea: payload => dispatch({ type: SET_AREA, payload })
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectArea);
